const initialState = { notes: {} };

export default function action(state = initialState, action) {

    let newState = naiveShallowCopy(state);

    switch (action.type) {

        case "ADD_ANSWERS":
            // must  be object since keys will be ID´s and if it´s array and key is not
            // consistent like 1,2,3,4,5,6   there will be element´s which are null
            newState[action.form] = action.payload[action.form] instanceof Array ? toObject(action.payload[action.form]) : action.payload[action.form];

            return newState;
        case "SELECT_ANSWER":

            if (typeof newState[action.form] === "undefined") {
                // must  be object since keys will be ID´s and if it´s array and key is not
                // consistent like 1,2,3,4,5,6   there will be element´s which are null
                newState[action.form] = {};
            }

            if (action.question.type === "checkbox") {

                if (typeof newState[action.form][action.question.id] === "undefined") {
                    newState[action.form][action.question.id] = [];
                }

                const answer_index = newState[action.form][action.question.id].indexOf(action.payload);

                if (answer_index === -1) {
                    newState[action.form][action.question.id].push(action.payload);
                } else {
                    newState[action.form][action.question.id].splice(answer_index, 1);
                }


            } else {
                newState[action.form][action.question.id] = action.payload;
            }


            return newState;

        case "SELECT_OTHER_ANSWER":

            if (typeof newState[action.form] === "undefined") {
                // must  be object since keys will be ID´s and if it´s array and key is not
                // consistent like 1,2,3,4,5,6   there will be element´s which are null
                newState[action.form] = {};
            }

            if (action.question.type === "checkbox") {

                if (typeof newState[action.form][action.question.id] === "undefined") {
                    newState[action.form][action.question.id] = [];
                }

                if (typeof action.payload.id !== "undefined") {
                    let changed = false;

                    for (let i = 0; i < newState[action.form][action.question.id].length; i++) {
                        if (newState[action.form][action.question.id][i].id === action.payload.id) {

                            // Check for toggle, since it's found, we remove it.
                            if (action.payload.toggle) {
                                newState[action.form][action.question.id].splice(i, 1);
                            } else {
                                newState[action.form][action.question.id][i] = action.payload;
                            }

                            changed = true;
                        }
                    }

                    if (!changed) {
                        newState[action.form][action.question.id].push(action.payload);
                    }

                } else {
                    const answer_index = newState[action.form][action.question.id].indexOf(action.payload);

                    if (answer_index === -1) {
                        newState[action.form][action.question.id].push(action.payload);
                    } else {
                        newState[action.form][action.question.id].splice(answer_index, 1);
                    }
                }

            } else {
                newState[action.form][action.question.id] = action.payload;
            }


            return newState;

        case "CHANGE_NOTE":

            newState.notes[action.question] = {
                text: action.payload,
                question: action.question,
                form: action.form,
                test: action.test
            };

            return newState;
        case "ADD_NOTES":

            action.payload.question_sections.forEach(section => {
                section.question_groups.forEach(group => {
                    group.questions.forEach(question => {
                        newState.notes[question.id] = {
                            text: typeof question.question_note[0] !== "undefined" ? question.question_note[0].text : "",
                            question: question.id,
                            form: action.payload.id,
                            test: action.test
                        };
                    })
                })
            });

            return newState;
        default:
            return state;
    }
}

/**
 * This function will copy object without any reference
 * so in our case, redux will detect change, since it does not
 * detect changes in nested objects, like our data is
 *
 * @param original
 * @returns {{}}
 */
function naiveShallowCopy(original) {
    let clone = {};
    let key;
    for (key in original) {
        clone[key] = original[key];
    }
    return clone;
}

function toObject(arr) {
    let rv = {};
    for (let i = 0; i < arr.length; i++) {
        rv[i] = arr[i];
    }
    return rv;
}


// WEBPACK FOOTER //
// ./src/redux/reducers/answers.js